import { Flex, Text } from '@mantine/core';
import { IconPlus } from './icons/IconPlus';

export type CreatLabelProps = {
  label: string;
};

export const CreateLabel = ({ label }: CreatLabelProps) => {
  return (
    <Flex
      py="md"
      gap="8px"
    >
      <IconPlus color="primary.0" />
      <Text
        color="primary.0"
        fw={700}
      >
        Add &quot;{label}&quot;
      </Text>
    </Flex>
  );
};
